import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesProductSets } from "../../constants";
import { ProductSetDetails } from "../../productsSets.types";

export const requestProductSetDetails = async (
  setId: string
): Promise<ProductSetDetails> => {
  return await instance.get(buildUrl(ApiRoutesProductSets.ProductSets, setId));
};
